export default __webpack_public_path__ + "static/media/github-link.d766470f.svg";